import { WeatherSettingsChangeSource } from '@fe/weather';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { MinimumIcingOptions } from '../settings-options';
import { useBooleanSetting, useDropdownSetting } from './hooks/useSetting';
import { Checkbox } from '@progress/kendo-react-inputs';

export default function IcingSettings() {
    const minimumIcingLevel = useDropdownSetting(
        MinimumIcingOptions,
        'turbulenceIcing',
        'minimumIcingLevel',
        WeatherSettingsChangeSource.icing
    );

    const applyTransparency = useBooleanSetting('turbulenceIcing', 'icingApplyTransparency', WeatherSettingsChangeSource.icingTransparency);

    return (
        <div className="d-flex gap-2 flex-column">
            <div>
                <div>Minimum icing level to display:</div>
                <DropDownList {...minimumIcingLevel} />
            </div>
            <Checkbox {...applyTransparency} label="Apply transparency" />
        </div>
    );
}
